exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".earn-points__label[data-v-81fcaa0a]:after {\n  position: absolute;\n  display: block;\n  border-top-width: 6px;\n  border-bottom-width: 6px;\n  border-left-width: 6px;\n  border-style: solid;\n  border-color: transparent;\n  z-index: 10;\n  border-left-color: #000;\n  content: '';\n  right: -6px;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n", ""]);

// exports
